import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import { type Account } from "./use-connected-accounts-query";

type Params = {
  email: string;
  label: string;
  instructions: string;
  appSpecificPassword: string;
  scopes: string[];
};

export const useAddICloudAccountMutation = () => {
  const queryClient = useQueryClient();
  const fetch = useAuthFetch();

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/connected-account/icloud`,
        {
          method: "POST",
          body: JSON.stringify({
            ...params,
            app_specific_password: params.appSpecificPassword,
          }),
        }
      );

      const data: { connected_accounts: Account[]; id: string } =
        await response.json();

      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: ["api", "connected-accounts"],
      });
    },
  });
};
